import React, { useState, useEffect } from "react";
import axios from 'axios';

export default function UserDropdown({ mobile, fName }) {
    const [dropdownShowing, setDropdownShowing] = useState(false);

    useEffect(() => {
        axios.defaults.withCredentials = true;
    }, []);

    const toggleDropdown = () => {
        setDropdownShowing(prev => !prev);
    };

    const signoutUser = async () => {
        try {
            const res = await axios.post('/api/signout', { withCredentials: true });
            if (res.status) {
                // Refresh Page
                window.location.reload(false);
            }
        } catch (err) {
            console.error(err);
        }
    };

    const renderDropdownContent = () => {
        if (!dropdownShowing) return null;

        const buttonClass = mobile
            ? "nav-links navbar-button"
            : "dashboard-button-clicked navbar-button";

        return (
            <>
                <div>
                    <a href="/dashboard" className={buttonClass} style={{ textDecoration: 'none', display: 'inline-block' }}>
                        Dashboard
                    </a>
                </div>

                <div>
                    <button onClick={signoutUser} className={buttonClass + ' signout-button'}>
                        Signout
                    </button>
                </div>
            </>
        );
    };

    // --- Main Render ---

    if (mobile) {
        return (
            <div className="highlight-link">
                <button onClick={toggleDropdown} className="nav-links navbar-button">
                    {fName} <i className="fa-solid fa-user"></i>
                    {dropdownShowing ? (
                        <i className="fa-solid fa-angle-up" />
                    ) : (
                        <i className="fa-solid fa-angle-down" />
                    )}
                </button>

                <div>
                    {renderDropdownContent()}
                </div>
            </div>
        );
    }

    // Desktop Return
    return (
        <>
            <div className="dropdown-button">
                <button onClick={toggleDropdown} className="dashboard-button">
                    {fName} <i className="fa-solid fa-user"></i>
                    {dropdownShowing ? (
                        <i className="fa-solid fa-angle-up" />
                    ) : (
                        <i className="fa-solid fa-angle-down" />
                    )}
                </button>
            </div>

            <div className="dashboard-dropdown">
                {renderDropdownContent()}
            </div>
        </>
    );
};